// src/components/Loader.tsx
import React from "react";
import { TailSpin } from "react-loader-spinner";

const Loader: React.FC = () => { 
  return (
    <div style={styles.container}>
      <TailSpin
        height="60"
        width="60"
        color="#1976d2"
        ariaLabel="tail-spin-loading"
        visible={true}
      />
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // position: "absolute",
    // height: "100vh",
    // width: "100",
    // left:" 50%",
    // backgroundColor: "rgba(0, 0, 0, 0.32)"

  } as React.CSSProperties,
};

export default Loader;
